<template >
  <div id="app" class="capitalize">
    <el-container style="height: 100vh">
      <el-header class="headerTop" style="width: 100%; height: 60px">
        <common-header></common-header>
      </el-header>

      <el-container style="overflow: auto">
        <!-- 路由页面  v-if="routerPage == `IndexIntroduce`||routerPage == `noWeb` "-->
        <div class="routePages" v-if="pageName !== `Web`">      
          <router-view class="capitalize"></router-view>
        </div>
        <!-- 组件页面 -->
        <div class="mainBOOS" v-if="pageName == `Web`">
          <div class="sidebar">        
            <common-aside></common-aside>      
          </div>
          <div class="outer">
            <el-container class="pageConcent">
              <el-main class="el_main">
                <router-view class="pages"></router-view>
              </el-main>
            </el-container>
          </div>
        </div>
      </el-container>
    </el-container>

    <!-- 指标解释 -->
    <el-col>
      <div
        v-show="pageName !== `IndexIntroduce`"
        @click="handelIndexIntroduce"
        class="i izhibiaoguanli indexIntroduce"
        :data-text="$t(`home.introduction`)"
        style="color: #6580a9; font-size: 50px"
      ></div>
    </el-col>
  </div>
</template>
<script>
import CommonAside from "./components/CommonAside.vue";
import CommonHeader from "./components/CommonHeader.vue";
import commonFooter from "./components/commonFooter.vue";
import * as echarts from "echarts";
export default {
  components: {
    CommonAside,
    CommonHeader,
    commonFooter,
  },
  data() {
    return {
      value: "1",
      options: [
        {
          value: "1",
          label: "Bitcoin (BTC)",
          src: "https://studio.glassnode.com/images/crypto-icons/btc.png",
        },
        {
          value: "2",
          label: "Ethereum (ETH)",
          src: "https://studio.glassnode.com/images/crypto-icons/eth.png",
        },
        {
          value: "3",
          label: "Litecoin (LTC)",
          src: "https://studio.glassnode.com/images/crypto-icons/ltc.png",
        },
        {
          value: "4",
          label: "Binance USD (BUSD)",
          src: "https://studio.glassnode.com/images/crypto-icons/busd.png",
        },
        {
          value: "5",
          label: "Gemini dollar (GUSD)",
          src: "https://studio.glassnode.com/images/crypto-icons/gusd.png",
        },
        {
          value: "6",
          label: "HUSD (HUSD)",
          src: "https://studio.glassnode.com/images/crypto-icons/husd.png",
        },
      ],
      // menuHeight: {
      //   height: "900px",
      // },
      bodyHeight: "",
      mainComponent: "mainStartCom",
      isShrink: false, //控制是否改变宽度
      fatherWidth: "300",
      pageWidth: 0,
      chart: null,
      routerPage: "web",
      pageName: "",
    };
  },
  created() {
    //动态调整左侧菜单栏高度 document.documentElement.clientHeight
    // var docHeight = document.body.clientHeight;

    // if (!docHeight) {
    //   this.menuHeight.height = 900 +`px`
    // }else{

    //   this.menuHeight.height = docHeight - 20 + "px";
    // }

    // this.menuHeight.height = docHeight - 20 + "px";
    // this.menuHeight.height=localStorage.getItem("screenHight")
    // 监听localstorage改变赋值
    this.bodyHeight = localStorage.getItem("screenHight");
    window.addEventListener("setItem", () => {
      this.bodyHeight = localStorage.getItem("screenHight");
    });
  },
  watch: {
    menuHeight: {
      handler(val) {
        // console.log(val.height, 1234565);
      },
      deep: true,
      immediate: true,
    },
    "$route.name"(newValue) {
      this.pageName = newValue;
    },
  },
  mounted() {
    this.pageName = this.$route.name;



    //监听localStorage
    window.addEventListener("setItem", () => {
      this.routerPage = JSON.parse(localStorage.getItem("routerPage"));
    });
  },
  methods: {
    //点击指标介绍 打开新窗口
    handelIndexIntroduce() {
      let url =
        window.location.origin +
        this.$router.resolve({ name: "IndexIntroduce" }).href;
      let a = window.open(url, "_blank");


    
    
    
    
    },
  },
};
</script>

<style lang="scss" scoped>
// -----------顶部导航栏------------------------
* {
  box-sizing: border-box;
}
html,
body {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
}
* {
  box-sizing: border-box;
}

.pageConcent {
  // outline: 1px solid red;
  // background: rgba(0,0,0, 0.1);
  // background-image: linear-gradient(to bottom, rgba(231,248,255,0.9),  rgba(0,0,0,0), rgba(0,0,0,0.1));
  background-image: linear-gradient(
    to bottom,
    rgba(231, 248, 255, 0.6),
    rgba(231, 248, 255, 0.6),
    rgba(231, 248, 255, 0.2),
    rgba(255, 255, 255, 0)
  );
  //  background: #fff;
  //     color: var(--okd-color-text-amplifed);
  // padding: 0px  1%;
  // width: 100%;
  min-height: 100%;
  // width:calc(100vw - 330px);
  // outline: 1px solid red;
  // background: firebrick;
  // background: #888888;
  width: 100%;

  .el_main {
    overflow-x: hidden;
    // width: 90%;
    // width: 20%;
    // width:calc(100vw - 330px);
    min-height: 100%;
    display: flex;
    justify-content: center;
    // background: green;
    width: 100%;
    // width: 74vw;
    .pages {
      width: 90%;
      min-height: 85%;

      margin: 80px 0px;
      box-shadow: 2px 5px 15px -5px #888888;
      padding: 30px 0px;
      // background: #fff;

      background: #fafdfe;
      // background: #383d71;
    }
  }
}

#app {
  // width: 100vw;
  // height: 100vh;
  box-sizing: border-box;
  // width: 100%;
  // height: 100%;
  // outline: 1px solid red;
  // background: honeydew;
  background-image: linear-gradient(
    to bottom,
    rgba(231, 248, 255, 1),
    rgba(231, 248, 255, 0.6),
    rgba(231, 248, 255, 0.6),
    #fff
  );

  // background: goldenrod;
  overflow-x: hidden;
  //loading 层级
  ::v-deep .el-loading-mask {
    z-index: 1998 !important;
  }

  .indexIntroduce {
    // outline: 1px solid red;
    position: fixed;
    top: 180px;
    right: 50px;
    width: 10px;
    height: 80px;
    border-radius: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .indexIntroduce:hover {
    color: #f7931a !important;
    // background: #f5390e;
    cursor: pointer;
  }
  .indexIntroduce:hover::after {
    content: attr(data-text); /* 显示的文字内容 国际化 */
    position: absolute;
    top: 80%;
    left: 50%;
    transform: translateX(-50%); /* 水平居中 */
    // padding: 5px; /* 内边距 */
    color: #000; /* 文字颜色 */
    font-size: 12px; /* 文字大小 */
    width: 60px;
    // outline: 1px solid red;
    text-align: center;
    color: #f7931a;
  }
}
#app .header {
  width: inherit;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  line-height: 60px;
  color: #b3c0d1;
  left: 0%;
  top: 0%;
  z-index: 1999.5;
  // outline: 1px solid red;
  padding: 0px 20px;
  // background: #383d71;
  color: #fff;
}
.el-card__body,
.el-main {
  padding: 2px;
}

.headList,
.headList2 {
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.5);
  // outline: 1px solid red;
  padding-inline-start: 0px;
  margin-block-end: 0px;
  margin-block-start: 0px;
}
.mainBOOS {
  //  outline: 1px solid red;
  min-width: 99vw;
  // height: calc(100vh - 60px);
  display: flex;

  height: 100vh;
}
// .mainBOOS  ::-webkit-scrollbar {
//   //隐藏滚动条
//   width: 0 !important;
//   height: 0;
// }

// .mainBOOS ::-webkit-scrollbar {
//   //隐藏滚动条
//   width: 0 !important;
// }
// .mainBOOS ::-webkit-scrollbar {
//   //隐藏滚动条
//   width: 0 !important;
//   height: 0;
// }
.sidebar {
  // width: 320px;
  height: calc(100vh - 60px);
  // background: red;
  background-image: linear-gradient(
    to bottom,
    rgba(231, 248, 255, 1),
    rgba(231, 248, 255, 0.6),
    rgba(231, 248, 255, 0.4),
   
  );

  box-shadow: 2px 5px 15px -5px #888888;
  position: relative;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1999;
}

.outer {
  // height: calc(100vh - 60px);
  // height: 100%;
  overflow-y: auto;
  // overflow-y: none;
  // background: #383d71;
  flex: 1;
  // outline: 1px solid red;
  // background: green;
  width: 100%;
  height: 100%;
}

// .outer > .pageConcent ::-webkit-scrollbar {
//   //隐藏滚动条
//   width: 0 !important;
//   height: 0;
// }

// ::-webkit-scrollbar {
//   //隐藏滚动条
//   width: 0 !important;
// }
// ::-webkit-scrollbar {
//   //隐藏滚动条
//   width: 0 !important;
//   height: 0;
// }
/* 设置滚动条的基本样式 */
::-webkit-scrollbar {
  width: 0px; /* 设置滚动条的宽度 */
}

/* 设置滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f5f5f5; /* 设置滚动条轨道的背景色 */
}

/* 设置滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #ccc; /* 设置滚动条滑块的背景色 */
  border-radius: 20px; /* 设置滚动条滑块的圆角 */
  // background: rgba(247,147,26, 0.1);
}

/* 设置滚动条滑块在鼠标悬停时的样式 */
::-webkit-scrollbar-thumb:hover {
  background-color: #888; /* 设置滚动条滑块在鼠标悬停时的背景色 */
}

li {
  list-style: none;
  height: 30px;
  line-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  //  outline: 1px solid red ;
}
li:hover {
  color: #000;
}
.headList li {
  margin-left: 15px;
  // outline: 1px solid red ;
}
.headList2 li {
  margin-left: 15px;
  // outline: 1px solid red ;
}
#app .headList2 li {
  // outline: 1px solid red ;
  padding: 5px 5px;
}
#app .headList li {
  // outline: 1px solid red ;
  padding: 5px 5px;
}
.registered {
  outline: 1px solid red;
  text-align: center;
  outline: 1px solid rgba(0, 0, 0, 0.2);
}

// -----------中间部分-------------------------
.middle {
  width: inherit;
  // height: 100px;
  outline: 1px solid;
  // background: green;
  padding-top: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.middle > .left {
  width: 280px;
  // height: 600px;
  // display: flex;
  // flex-direction: column;
  background: paleturquoise;
  padding-top: 60px;
}
.middle > .right {
  display: flex;
  flex: 1;
  height: 600px;
  background: khaki;
}
// -----------侧边栏----------------------------

.left .search {
  width: inherit;
  height: 60px;
  outline: 1px solid red;
  position: fixed;
  top: 60px;
  left: 0px;
  background: pink;
}
.left .sidebar {
  outline: 1px solid red;
  // width: inherit;
}

// .sidebar {
//   width: 25%;
//   height: 100vh;
//   outline: 1px solid red;
//   background: honeydew;
//   margin-top: 41px;
//   padding: 1px;
//   position: relative;
//   display: flex;
// }
// 侧边导航
// .sidebarNav {
//   width: 100%;
//   display: flex;
//   flex: 1;
//   outline: 1px solid red;
//   margin-top: 80px;
// }
// ---------------搜索下拉框样式-----------------------
// .search {
//   width: 280px;
//   height: 35px;
//   line-height: 35px;
//   outline: 1px solid red;
//   // background: red;
//   margin-top: 10px;
//   position: fixed;
//   top: 40px;
//   left: 20px;
//   z-index: 99;
// }
// .dark-select {
//   border: 1px solid rgba(0, 0, 0, 0.5);
//   width: 200px;
//   border-radius: 5px;
//   margin-top: 40px;
//   display: inline-block;
//   // margin-top: 10px;

//   .el-select-dropdown__item {
//     line-height: 30px;
//     height: 30px;
//   }

//   .el-select .el-input .el-select__caret.el-icon-::before {
//     content: "\e790";
//     position: absolute;
//     width: 100%;
//     height: 100%;
//     top: 50%;
//     left: 50%;
//     transform: translate(-50%, -50%);
//   }
//   // 修改input默认值颜色 兼容其它主流浏览器
//   input::-webkit-input-placeholder {
//     // color: rgba(255, 255, 255, 0.60);
//     color: rgba(0, 0, 0, 0.4);
//   }
//   input::-moz-input-placeholder {
//     // color: rgba(255, 255, 255, 0.60);
//     color: rgba(0, 0, 0, 0.6);
//   }
//   input::-ms-input-placeholder {
//     // color: rgba(255, 255, 255, 0.60);
//     color: rgba(0, 0, 0, 0.6);
//   }
//   // input框
//   .el-select,
//   .el-input,
//   .el-input__inner {
//     // background-color: rgba(0, 0, 0, 0.3);
//     background-color: rgba(255, 255, 255, 0.1);

//     // background-color: #ccc;
//     // color: rgba(255, 255, 255, 0.50);
//     // color: #fff;
//     // border: 1px solid #000;
//     // outline: 1px solid #000;
//     outline: none;
//     border: none; // 去掉边框
//     // border-color: "#000";// 默认边框的颜色
//     // text-align: left;
//     // border-radius: 4px;
//   }

//   // 选中时边框颜色
//   // .el-input__inner:focus{
//   //       border-color: "#000"
//   //   }

//   // 鼠标悬浮时 input框颜色
//   //  .el-input__inner:hover{
//   //         background-color: rgba(0, 0, 0, 0.3);
//   //     }

//   // input框 右侧的箭头
//   //  .el-select .el-input .el-select__caret {
//   //         color: rgba(255, 255, 255, 0.50);
//   //     }

//   // option选项 上面的箭头
//   // .el-popper[x-placement^="bottom"] .popper__arrow::after {
//   //         // border-bottom-color: rgba(43, 45, 55, 0.80);
//   //         // border-bottom-color: rgba(0, 0, 0, 0.10);
//   //         //  background: rgba(0, 0, 0, 0.2);
//   //         // z-index: 9999;
//   //     }
//   // .popper__arrow {
//   //         border: none;
//   //     }
//   // option选项 最外层
//   .el-select-dropdown {
//     // border: none !important;
//     // background: rgba(43, 45, 55, 0.80) !important;
//     // background: rgba(0, 0, 0, 0.2) !important;
//     // background: #fff;
//     border: 1px solid rgba(0, 0, 0, 0.2);
//     z-index: 9;
//   }
//   // option选项 文字样式
//   .el-select-dropdown__item {
//     // color: rgba(255, 255, 255, 0.50) !important;
//     // color: rgba(0, 0, 0, 0.50) !important;
//     // color: #000;
//     z-index: 9;
//     font-size: 12px;
//   }
//   .el-select-dropdown__item.selected span {
//     // color: rgba(255, 255, 255, 0.80) !important;
//     //  color: rgba(0, 0, 0, 0.50) !important;\ \
//     font-size: 12px;
//     z-index: 9;
//   }
//   // 移入option选项 样式调整
//   // .el-select-dropdown__item {
//   //   height: 20px;
//   //   margin-top: 10px;
//   // }
//   // // .el-select-dropdown__item.hover {
//   //   // background-color: rgba(255, 255, 255, 0.06);
//   //   // background-color: #d2d6e8;

//   //   // color: rgba(255, 255, 255, 0.60) !important;
//   //   z-index: 9999;
//   // }

//   // 下拉框垂直滚动条宽度
//   // .el-scrollbar__bar.is-vertical {
//   //        width: 10px;
//   //        top: 2px;
//   //    }
//   // 下拉框最大高度
//   //  .el-select-dropdown__wrap {
//   //        max-height: 200px;
//   //    }
// }

.option {
  display: flex;
  align-items: center;
  justify-content: left;
  .label {
    margin-left: 5px;
  }
}

// ------------子导航加内容整体盒子-------------------------
// .contents {
//   width: 79vw;
//   position: absolute;
//   top: 0px;
//   right: 0px;
//   border: 1px solid rgba(0, 0, 0, 0.3);
//   background: res;
// }
// .el-card__body,
// .el-main {
//   padding: 0px !important;
// }
// .el-header {
//   // background-color: #b3c0d1;
//   height: 40px !important;
//   display: flex;
//   align-items: center;
//   color: #333;
//   // background: #b3c0d1;
//   border-bottom: 1px solid rgba(0, 0, 0, 0.2);
// }
// // -------子导航----第二横向导航栏-------------------------
// .sc-jGprRt {
//   display: flex;
//   align-items: center;
//   //  outline: 1px solid  red;
//   width: 300px;
//   justify-content: space-around;
// }
// .sc-jGprRt button {
//   display: flex;
//   // outline: 1px solid  red;
//   border: 1px solid rgba(0, 0, 0, 0.2);
//   color: rgba(0, 0, 0, 0.6);
//   padding: 2px 5px;
//   align-items: center;
//   justify-content: space-around;
//   transition: linear 0.2s;
//   border-radius: 2px;
// }
// .sc-jGprRt button:hover {
//   border: 1px solid rgba(0, 0, 0, 0.6);
// }

// // .el-aside {
// //   color: #333;
// //   // color: #ccc;

// // }
// ::-webkit-scrollbar {
//   //隐藏滚动条
//   width: 0 !important;
// }
// ::-webkit-scrollbar {
//   //隐藏滚动条
//   width: 0 !important;
//   height: 0;
// }

// // ----------侧边栏-------------------------------
// .optionItem span {
//   margin-left: 10px;
// }
// .aside {
//   outline: 1px slid red;
// }
// .el-submenu .el-submenu__title {
//   height: 35px;
//   line-height: 35px;
//   display: flex;
//   align-items: center;
//   font-size: 12px;
// }
// .el-submenu .el-menu-item {
//   height: 30px !important;
//   // width: inherit;
//   white-space: nowrap; //不换行
//   text-overflow: ellipsis; //将文本溢出显示为（…）
//   overflow: hidden; //溢出隐藏。

//   line-height: 30px !important;
//   margin: 0px;
//   padding-left: 25px !important;
//   font-size: 10px !important;
//   // outline: 1px solid red;
// }
// //子选项
// .itemT1 span:nth-of-type(1) {
//   color: rgb(104, 113, 152);
//   display: inline-block;
//   vertical-align: middle;
//   // outline: 1px solid red;
//   background: rgb(229, 231, 240);
//   font-size: 0.75rem;
//   font-weight: bold;
//   text-transform: capitalize;
//   border-radius: 4px;
//   height: 20px;
//   width: 20px;
//   text-align: center;
//   line-height: 20px;
// }
// .el-menu-item-group__title {
//   padding-left: 20px !important;
// }
// .itemT2 span:nth-of-type(1) {
//   display: inline-block;
//   vertical-align: middle;
//   width: 20px;
//   height: 20px;
//   line-height: 20px;
//   font-size: 0.75rem;
//   font-weight: bold;
//   overflow: hidden;
//   border-radius: 4px;
//   text-align: center;
//   letter-spacing: -1px;
//   white-space: nowrap;
//   text-transform: capitalize;
//   background: rgb(230, 238, 255);
//   color: rgb(35, 110, 254);
// }
// .itemT3 span:nth-of-type(1) {
//   display: inline-block;
//   vertical-align: middle;
//   width: 20px;
//   height: 20px;
//   line-height: 20px;
//   font-size: 0.75rem;
//   font-weight: bold;
//   overflow: hidden;
//   border-radius: 4px;
//   text-align: center;
//   letter-spacing: -1px;
//   white-space: nowrap;
//   text-transform: capitalize;
//   background: rgb(250, 233, 237);
//   color: rgb(254, 109, 145);
// }
// .title2 {
//   display: inline;
//   margin-left: 10px;
//   color: rgba(0, 0, 0, 0.6);
// }
//
//
// .el-container.is-vertical {
//   flex-direction: row;
// }
// // .el-main{
// //   background: red;
// //   position: absolute;
// //   top: 0px;
// //   left: 0px;

// // }
.resize {
  cursor: col-resize;
  position: absolute;
  right: 0;
  height: 100%;
  width: 5px;
}
.routePages {
  min-width: 99vw;
  height: 93.5vh;
  // outline: 1px solid red;
  // background: gold;
  // padding: 20px;
  // overflow-y: auto;

  box-sizing: border-box;
  // overflow: hidden;
  .jumpHome {
    // outline: 1px solid red;
    width: 100%;
    display: inline-block;
    text-align: right;
    height: 30px;
    line-height: 50px;
    color: rgba(0, 0, 0, 0.9);

    span {
      position: fixed;
      right: 20px;
      top: 60px;
      font-size: 14px;
      font-weight: 600;
    }
    span:hover {
      color: #f7931a;
    }
  }
}
</style>

<style lang="scss">
/* 警告语层级 */
.messageClass {
  z-index: 999999 !important;
}
//公式的公共样式
.formulas {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 550;
  color: rgba(0, 0, 0, 0.6);
  div:nth-of-type(2) {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    span {
      text-align: center;
    }
    span:nth-of-type(1) {
      border-bottom: 1px solid rgba(0, 0, 0, 1);
    }
  }
}
</style>